module.exports = new __parcel__URL__("quake-iii-arena.75fe5a8a.jpg").toString();